export const FETCH_SELECTED_CONTENT_PENDING = 'FETCH_SELECTED_CONTENT_PENDING';
export const FETCH_SELECTED_CONTENT_SUCCESS = 'FETCH_SELECTED_CONTENT_SUCCESS';
export const FETCH_SELECTED_CONTENT_ERROR = 'FETCH_SELECTED_CONTENT_ERROR';
